import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hlahqfmphbtoobvmzaqg.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhsYWhxZm1waGJ0b29idm16YXFnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY5MDAxNjEsImV4cCI6MjA1MjQ3NjE2MX0.-mtYxM-vLOwHt52sNya-u05E55muNNdY4JgWC8Rg9ss";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce'
    },
  }
);